import { theme } from '@client/theme/constants';
import type { ThemeOptions } from '@mui/material';

const Avatar: ThemeOptions['components'] = {
  MuiAvatar: {
    styleOverrides: {
      root: {
        fontSize: theme.spacing(3),
      },
    },
  },
  MuiAvatarGroup: {
    styleOverrides: {
      avatar: {
        border: 0,
      },
      root: {
        '& > *': {
          border: '0 !important',
        },
      },
    },
  },
};

export default Avatar;
